import * as React from "react";

function SvgZaius(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 594 136"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...{ ...props, ref }}
    >
      <defs>
        <path
          d="M1003.662 104.123c-8.578 6.54-18.557 9.798-29.944 9.798-10.806 0-19.848-1.498-27.09-4.524-7.25-3.002-13.458-7.027-18.63-12.063l15.531-15.077c5.174 6.046 13.977 9.554 26.387 10.553 10.359 0 16.806-2.123 19.37-6.403 2.56-4.275 2.56-8.537 0-12.812-2.564-4.275-9.011-6.908-19.37-7.919-9.312-1.005-17.852-3.775-25.621-8.294-7.757-4.518-11.633-12.312-11.633-23.37 0-10 4.402-18.026 13.23-24.09 8.823-6.058 17.89-9.084 27.22-9.084 10.806 0 19.193 1.26 25.138 3.775 5.963 2.509 11.528 6.278 16.701 11.308l-15.526 15.07c-5.185-6.034-12.428-9.042-21.746-9.042-9.306 0-15.263 2.134-17.852 6.41-2.584 4.274-2.584 7.918 0 10.932 2.59 3.014 8.546 5.274 17.852 6.784 9.838 1.004 18.77 4.15 26.785 9.429 8.02 5.273 12.036 13.692 12.036 25.255 0 9.043-4.286 16.83-12.838 23.364zm-116.726-31.67c0 11.564-4.788 21.373-14.363 29.417s-21.6 12.051-36.103 12.051c-14.485 0-26.521-4.007-36.097-12.05-9.575-8.045-14.362-17.854-14.362-29.418V.838h23.295V66.43c0 8.543 2.583 14.821 7.769 18.852 5.16 4.013 11.638 6.029 19.395 6.029 7.77 0 14.234-2.016 19.42-6.029 5.167-4.03 7.763-10.309 7.763-18.852V.838h23.283v71.615zm-170.682 41.468V.761h23.21v113.16h-23.21zm-67.834 0l-6.985-17.336h-52.792l-6.992 17.336h-24.844L603.391.838h23.289l46.504 113.012-24.764.071zM473.714 135.24l11.558-21.181h-61.363l59.336-92.146H423.5L434.027.76h92.895l-59.498 92.151h58.82l-52.53 42.327zM597.96 73.964h34.933L615.66 30.992l-17.7 42.972z"
          id="Zaius_svg__a"
        />
      </defs>
      <g transform="translate(-423)" fill="none" fillRule="evenodd">
        <use fill="#12A7E0" xlinkHref="#Zaius_svg__a" />
        <use xlinkHref="#Zaius_svg__a" />
        <use xlinkHref="#Zaius_svg__a" />
        <use xlinkHref="#Zaius_svg__a" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgZaius);
